import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { Box, Stack, Typography } from '@mui/material';

import SectionCard from '../../components/SectionCard';
import PreviewText from '../../components/PreviewText';
import { substituteForPreview } from '../../utils/composeBodyPreview';
import PreviewImage from '../../components/PreviewImage';
import texts from '../../texts.json';
import { PreviewDayLabel, PreviewBubble } from '../style';

const copy = texts.reengagement.preview;

const ReEngagementPreview = ({ blasts, coachName }) => (
  <SectionCard title={copy.title}>
    {blasts.length === 0 ? (
      <Typography variant="body2" color="text.secondary">{copy.empty}</Typography>
    ) : (
      <Stack spacing={2}>
        {blasts.map((blast) => {
          const imageUrl = blast.image?.previewUrl || blast.image?.url;
          return (
            <Box key={blast.key}>
              <PreviewDayLabel>{format(copy.dayLabel, { offset: blast.dayOffset })}</PreviewDayLabel>
              <PreviewBubble>
                {imageUrl && <PreviewImage src={imageUrl} />}
                <PreviewText>{substituteForPreview(blast.body, { coachName })}</PreviewText>
              </PreviewBubble>
            </Box>
          );
        })}
      </Stack>
    )}
    <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
      {copy.stopNote}
    </Typography>
  </SectionCard>
);

ReEngagementPreview.propTypes = {
  blasts: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    dayOffset: PropTypes.number,
    body: PropTypes.string,
    image: PropTypes.shape({
      previewUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  })).isRequired,
  coachName: PropTypes.string,
};

ReEngagementPreview.defaultProps = {
  coachName: '',
};

export default ReEngagementPreview;
